import { render, staticRenderFns } from "./RequestGeneralInfo.vue?vue&type=template&id=81189cfa"
import script from "./RequestGeneralInfo.vue?vue&type=script&lang=js"
export * from "./RequestGeneralInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports